var DEFAULT_COLOUR = 'black';

export default angular.module('syIcon', [])
    /**
     * @ngdoc directive
     * @name icon.service:IconService
     * @description
     * Contains functions to help render icons.
     */
    // @ngInject
    .service('IconService', [function () {
        // Generate the SVG url based on the icon name and colour
        this.generateSVGUrl = function (name, colour) {
            return '/SvgRender/' + name + '/' + (colour && colour !== '' ? colour : DEFAULT_COLOUR);
        }
    }])
    /**
     * @ngdoc directive
     * @name icon.directive:syIcon
     * @description
     * Simple directive to set the background image of the element using JS.
     */
    // @ngInject
    .directive('syIcon', ['IconService', function (IconService) {
        return {
            link: function ($scope, $element, attrs) {
                if (attrs.syIcon && attrs.syIcon !== '') {
                    $element.css('background-image', 'url("' + IconService.generateSVGUrl(attrs.syIcon, attrs.colour) + '")');
                }
                if (attrs.background && attrs.background !== '') {
                    $element.css('background-color', attrs.background);
                }
            }
        };
    }]);